module.exports = __webpack_public_path__ + "media/icons/dark-bg-ajax-loader-f3c9fe14.gif";